export function useAuthInfo() {
  const authInfoStore = useAuthInfoStore()

  return {
    isAuthenticated: authInfoStore.isAuthenticated,
    idToken: authInfoStore.authInfo.idToken,
    accessToken: authInfoStore.authInfo.accessToken,
    authInfo: authInfoStore.authInfo,
    setAuthInfo: authInfoStore.setAuthInfo,
    resetAuthInfo: authInfoStore.resetAuthInfo,
  }
}
